import React, { Fragment } from 'react'
import { Breadcrumb } from 'react-bootstrap'

const LoadingComponent = ({ breadCrubTitle, breadCrubParent }) => {
    return (
        <div style={{ width: '100%', position: 'relative' }}>
            <Fragment >
                <Breadcrumb title={breadCrubTitle} parent={breadCrubParent} />
                <div style={{ width: '100%', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <div style={{ textAlign: 'center' }}>
                        <div style={{
                            width: '40px',
                            height: '40px',
                            border: '4px solid #f3f3f3',
                            borderTop: '4px solid #3498db',
                            borderRadius: '50%',
                            animation: 'spin 1s linear infinite',
                            margin: '0 auto 10px'
                        }}></div>
                        <div style={{ fontSize: '16px', color: '#666' }}>Loading...</div>
                    </div>
                </div>
                <style jsx>{`
                    @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }
                `}</style>
            </Fragment>
        </div>
    )
}

export default LoadingComponent